import en from 'vee-validate/dist/locale/en.json';

export default {
    // Start breadcrumbs. Temporary decision. Fix it into Breadcrumbs component
    Games: 'Games',
    Articles: 'Articles',
    EsportArticles: 'Esport Articles',
    Esport: 'Esport',
    Hardware: 'Hardware',
    News: 'News',
    Trending: 'Trending News',
    Events: 'Events News',
    // End breadcrumbs
    validation: en.messages,
    labels: {
        seeAlso: 'See also',
        restricted: 'Member',
        author: 'Author',
        onlyAuth: 'Available for registered users only'
    },
    pages: {
        home: {
            title: 'Home',
            mostPopularGames: 'Most popular games',
            newGamesOnSite: 'New games on site',
            newsAndUpdates: 'News & Updates',
            bestPlaygrounds: 'Best Playgrounds',
            allGames: 'All Games',
            gameRelease: 'Release',
            sections: {
                topGames: {
                    term1: 'Top {count}',
                    term2: 'Games',
                },
                trendingNews: {
                    term1: 'Trending',
                    term2: 'News',
                },
                newGameArticles: {
                    term1: 'New',
                    term2: 'Game Articles',
                },
                newEsportArticles: {
                    term1: 'New',
                    term2: 'Esport Articles',
                },
                newGames: {
                    term1: 'New',
                    term2: 'Games',
                },
            },
        },
        games: {
            title: 'Games',
            newGamesInAMonth: 'New games in a month',
            newGamesThisWeek: 'New games this week',
            newGamesNextWeek: 'New games next week',
            rating: 'Rating',
            years: 'Years',
            platforms: 'Platforms',
            genres: 'Genres',
            allPlatforms: 'All platforms',
            allGenres: 'All genres',
            whereToPlay: 'Where to play?',
            singleGamePage: {
                release: 'Release',
                developer: 'Developer',
                website: 'Website',
                latestComments: 'Latest comments',
                aboutGame: 'About game',
                gamePassingStrategy: 'Game passing strategy',
                videos: 'Videos',
                screenshots: 'Screenshots',
                writtenBy: 'Written by',
                source: 'Source',
                imageFrom: 'Image from',
                twitchSection: {
                    title: {
                        term1: 'Stream ',
                        term2: 'on',
                    },
                    streamEmpty: {
                        term: 'Currently, nothing to view by {gameName}.{br} Please try again later.',
                    },
                },
            },
        },
        articles: {
            title: 'Articles',
            gameInTheme: 'Game in theme',
            sections: {
                recentArticles: 'Recent Articles',
                popularArticles: 'Popular Articles',
                recommendedArticles: 'Recommended Articles',
                relatedArticles: 'Related Articles',
            },
        },
        esportArticles: {
            title: 'Esport Articles',
            sections: {
                recommendedEsportArticles: 'Recommended Esport Articles',
                relatedEsportArticles: 'Related Esport Articles',
            },
        },
        esport: {
            title: 'Esport',
            sections: {
                esportNews: {
                    term1: 'Esport',
                    term2: 'News',
                    title: 'Esport News',
                },
                popular: {
                    title: 'Popular',
                },
                popularArticles: {
                    term1: 'Popular',
                    term2: 'Articles',
                },
                moreArticles: {
                    title: 'More Articles',
                },
            },
            mainHeading: 'Choose your game !',
            trending: 'Trending News',
            events: 'Events News',
            mixNews: 'Mix News',
            relatedArticles: 'Related articles',
            publications: 'Publications',
            esportSinglePage: {
                developer: 'Developer',
                website: 'Website',
                image: 'Image',
                imageFrom: 'Image from',
            },
        },
        news: {
            title: 'News',
            mainHeading: 'Gaming News',
            sections: {
                popularNews: {
                    term1: 'Popular',
                    term2: 'News',
                    title: 'Popular News',
                },
                recentNews: {
                    term1: 'Recent',
                    term2: 'News',
                    title: 'Recent News',
                },
                relatedNews: 'Related News',
                recommendedNews: 'Recommended News',
                trending: 'Trending',
                readMore: 'Read More',
                latest: 'Latest',
            },
            singleNewsPage: {
                gamesOfNews: 'Games of news',
            },
        },
        about: {
            title: 'About',
            mainHeading: 'About ASK4GAMES',
            descriptionParaOne: 'ASK4GAMES is a team of developers, writers and managers. We are interested in everything related to the video game industry. Cyber-sports events, gaming news reviews and scrupulous analysis of actual hardware - this is the list of our interests.',
            descriptionParaTwo: 'If you see yourself in the game journalist among team - feel free to write to us. If you have no work experience, but would like to learn the profession - also write, and we will consider your candidacy.',
            sections: {
                subheading: 'How we work',
                firstSection: {
                    heading: 'Let\'s play.',
                    paragraph: 'We play, leave notes for ourselves, and underline our general impression of the game. Combine business with pleasure, but don\'t forget about work!'
                },
                secondSection: {
                    heading: 'Write.',
                    paragraph: 'We cover the talking points, form the structure of the article, and work on the meanings. Then we edit the material to the point where the result is a little something to be proud of. Sometimes there is a passing game, but there shouldn\'t be a passing read.'
                },
                thirdSection: {
                    heading: 'Resting after work.',
                    paragraph: 'We give ourselves a rest and recharge our energy for new achievements. Game journalistic is not a profession where you can slack off. We understand that an employee should not feel like a squeezed-out lemon, but our loyal attitude to people is not a reason to sit on our necks. Kind does not mean naive.'
                },
                fourthSection: {
                    heading: 'Payment anywhere in the world.',
                    paragraph: 'Modern problems require modern solutions. Your country of residence does not matter - we receive and send transactions anywhere. If you still have doubts - let go. We\'ll explain and give you step-by-step instructions in simple, easy-to-understand language. Your money is safe with us.'
                },
            }
        },
        community: {
            title: 'Community',
        },
        hardware: {
            title: 'Hardware',
            sections: {
                news: {
                    title: 'News',
                },
                popularNews: {
                    title: 'Popular News',
                },
            },
        },
        whereToPlay: {
            title: 'Where to play',
        },
        contact: {
            title: 'Contact',
            // subTitle: 'Other ways to contact us',
            subTitle: 'We love to hear you, contact us',
            para1: 'If you have any specific questions or want to talk to an Ask4Games support representative, email us. Please contact our Support Center for problem-solving or submit a support request.',
            // para1: 'Send us an email and we’ll get back to you shortly.',
            para2: 'Please contact our Support Center for problem solving or submit a support request.',
            para3: 'If you have any specific inquiries, or would like to talk with an Ask4Games support representative, we are available over live chat.',
            supportDept: 'Support',
            partnershipsDept: 'Partnerships',
            financeDept: 'Finance',
            salesDept: 'Sales',
        },
        authors: {
            title: 'Authors',
            tabsTitle: {
                comments: 'Comments',
                games: 'Games',
                publications: 'Publications',
            },
            tracksGames: 'Tracks games',
            authorInfoCard: {
                lastVisit: 'Last visit',
                birthDate: 'Birth date',
                age: 'Age',
                gender: 'Gender',
                onTheSite: 'On the site',
                aboutMe: 'About me',
                publications: 'Publications',
            },
        },
        join: {
            title: 'Sign Up',
        },
        login: {
            title: 'Sign In',
        },
        becomeAnAuthor: {
            title: 'How do you become an author?',
            description: 'Do you understand the video game industry, and did your essays at school enthrall the literature teachers? We have something to offer you - become our author.',
            sections: {
                firstSection: {
                    heading: 'When a hobby becomes a job',
                    paragraph: 'Being an Ask4games author is not only a way to express yourself, but also an opportunity to make a name for yourself in Game Journalistic. Your articles will be judged by players just like yourself. Find the pinnacle of your writing talents, rather than writing in the desk in the ghostly hope that your portfolio will ever get noticed.'
                },
                secondSection: {
                    heading: 'Own fan base',
                    paragraph: 'Over time, you will have your own circle of readers. Your handwriting and style will be recognized, and your articles will be shared on social networks. It is quite possible that among the authors you will meet "uncut diamonds" of journalism and masters of the pen.'
                },
                thirdSection: {
                    heading: 'The problems of writing people',
                    paragraph: 'There\'s usually one problem that pops up in writers sooner or later: you can already boast about your first work or article, but you can\'t boast about your readers. It\'s hard to grow and develop in something when your creative endeavors are somewhere in the shadows. If you\'ve ever once again quit writing "forever" - you know the feeling of uncertainty when you reflect on sleepless nights: am I an unrecognized genius or a simple graphomaniac? We don\'t guarantee that there will be training sessions based on examples of your work, but we do guarantee attention to your essays.'
                },
                fourthSection: {
                    heading: 'How about a career?',
                    paragraph: 'The reader is different: one will see in your text only a general recommendation or interesting information, while others will pay attention to your style, the ability to express the idea succinctly. Perhaps at some point an experienced specialist will pay attention to your articles and objectively evaluate the work. But to listen to criticism or not - the choice is yours. Keep in mind that by associating your life with the text at some point the unexpected will happen - you will suddenly become famous. Let the narrow circles, but about you will spread the word. What can be better when there is no need again and again to competently put yourself in front of the bosses? That\'s right, when they heard your name on word of mouth and found you themselves.'
                },
            }
        },
        termsAndConditions: {
            title: 'Terms and Conditions',
            welcome: 'Welcome to Ask4Games!',
            termsParaOne: 'These terms and conditions outline the rules and regulations for the use of Ask4Games LLC\'s Website, located at {link}',
            termsParaTwo: 'By accessing this website we assume you accept these terms and conditions. Do not continue to use Ask4Games if you do not agree to take all of the terms and conditions stated on this page.',
            termsParaThree: 'The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.',
            sections: {
                cookiesSection: {
                    title: 'Cookies',
                    paraOne: 'We employ the use of cookies. By accessing Ask4Games, you agreed to use cookies in agreement with the Ask4Games LLC\'s Privacy Policy.',
                    paraTwo: 'Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.',
                },
                licenseSection: {
                    title: 'License',
                    paraOne: 'Unless otherwise stated, Ask4Games LLC and/or its licensors own the intellectual property rights for all material on Ask4Games. All intellectual property rights are reserved. You may access this from Ask4Games for your own personal use subjected to restrictions set in these terms and conditions.',
                    listTitle: 'You must not:',
                    listItemOne: 'Republish material from Ask4Games;',
                    listItemTwo: 'Sell, rent or sub-license material from Ask4Games;',
                    listItemThree: 'Reproduce, duplicate or copy material from Ask4Games;',
                    listItemFour: 'Redistribute content from Ask4Games.',
                },
                ageSection: {
                    title: 'Age',
                    paraOne: 'You must be at least 18 years old in order to access Ask4Games. If you are under 18 years of age, your parent or legal guardian must agree to our these terms and conditions and Privacy Policy on your behalf',
                    paraTwo: 'This Agreement shall begin on the date hereof. Our Terms and Conditions were created with the help of the {paraTwoLink}',
                    paraTwoLink: 'TermsFeed Free Terms and Conditions Generator',
                    paraThree: 'Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Ask4Games LLC does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Ask4Games LLC,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Ask4Games LLC shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.',
                    paraFour: 'Ask4Games LLC reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.',
                    paraFive: 'You hereby grant Ask4Games LLC a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.',
                    listTitle: 'You warrant and represent that:',
                    listItemOne: 'You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;',
                    listItemTwo: 'The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;',
                    listItemThree: 'The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy;',
                    listItemFour: 'The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.',
                },
                contentHyperlinkingSection: {
                    title: 'Hyperlinking to our Content',
                    lists: {
                        listOne: {
                            orderedListItem: 'The following organizations may link to our Website without prior written approval:',
                            nestedListItemOne: 'Government agencies;',
                            nestedListItemTwo: 'Search engines;',
                            nestedListItemThree: 'News organizations;',
                            nestedListItemFour: 'Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses;',
                            nestedListItemFive: 'System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.',
                        },
                        listTwo: {
                            orderedListItem: 'We may consider and approve other link requests from the following types of organizations:',
                            nestedListItemOne: 'commonly-known consumer and/or business information sources;',
                            nestedListItemTwo: 'dot.com community sites;',
                            nestedListItemThree: 'associations or other groups representing charities;',
                            nestedListItemFour: 'online directory distributors;',
                            nestedListItemFive: 'internet portals;',
                            nestedListItemSix: 'accounting, law and consulting firms;',
                            nestedListItemSeven: 'educational institutions and trade associations.',
                        },
                        listThree: {
                            listTitle: 'Approved organizations may hyperlink to our Website as follows:',
                            listItemOne: 'By use of our corporate name;',
                            listItemTwo: 'By use of the uniform resource locator being linked to;',
                            listItemThree: 'By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party’s site.',
                        },
                    },
                    paraOne: 'These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party’s site.',
                    paraTwo: 'We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Ask4Games LLC; and (d) the link is in the context of general resource information.',
                    paraThree: 'These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party’s site.',
                    paraFour: 'If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Ask4Games LLC. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.',
                    paraFive: 'No use of Ask4Games LLC\'s logo or other artwork will be allowed for linking absent a trademark license agreement.',
                },
                iFramesSection: {
                    title: 'iFrames',
                    paraOne: 'Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.',
                },
                contentLiabilitySection: {
                    title: 'Content Liability',
                    paraOne: 'We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.',
                },
                privacySection: {
                    title: 'Your Privacy',
                    paraOne: 'Please read',
                    link: 'Privacy Policy',
                },
                reservationOfRightsSection: {
                    title: 'Reservation of Rights',
                    paraOne: 'We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.',
                },
                removalOfLinksSection: {
                    title: 'Removal of links from our website',
                    paraOne: 'If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.',
                    paraTwo: 'We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.',
                },
                disclaimerSection: {
                    title: 'Disclaimer',
                    listTitle: 'To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:',
                    listItemOne: 'limit or exclude our or your liability for death or personal injury;',
                    listItemTwo: 'limit or exclude our or your liability for fraud or fraudulent misrepresentation;',
                    listItemThree: 'limit any of our or your liabilities in any way that is not permitted under applicable law;',
                    listItemFour: 'exclude any of our or your liabilities that may not be excluded under applicable law.',
                    paraOne: 'The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.',
                    paraTwo: 'As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.',
                },
            }
        },
        privacyPolicy: {
            title: 'Privacy Policy',
            lastUpdate: 'Last updated: June 22, 2022',
            privacyParaOne: 'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.',
            privacyParaTwo: 'We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.',
            sections: {
                interpretationAndDefinitions: {
                    title: 'Interpretation and Definitions',
                    interpretation: {
                        title: 'Interpretation',
                        paraOne: 'The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.',
                    },
                    definitions: {
                        title: 'Definitions',
                        definitions: {
                            account: 'Account',
                            company: 'Company',
                            cookies: 'Cookies',
                            country: 'Country',
                            device: 'Device',
                            personalData: 'Personal Data',
                            service: 'Service',
                            serviceProvider: 'Service Provider',
                            usageData: 'Usage Data',
                            website: 'Website',
                            you: 'You',
                        },
                        listTitle: 'For the purposes of this Privacy Policy:',
                        listItemOne: '{definitions} means a unique account created for You to access our Service or parts of our Service.',
                        listItemTwo: '{definitions} (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Ask4Games LLC, TBD.',
                        listItemThree: '{definitions} are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.',
                        listItemFour: '{definitions} refers to: Cyprus.',
                        listItemFive: '{definitions} means any device that can access the Service such as a computer, a cellphone or a digital tablet.',
                        listItemSix: '{definitions} is any information that relates to an identified or identifiable individual.',
                        listItemSeven: '{definitions} refers to the Website.',
                        listItemEight: '{definitions} means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.',
                        listItemNine: '{definitions} refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).',
                        listItemTen: '{definitions} refers to Ask4Games, accessible from {link}',
                        listItemEleven: '{definitions} means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.',
                    },
                },
                usingPersonalData: {
                    title: 'Collecting and Using Your Personal Data',
                    typesOfData: {
                        title: 'Types of Data Collected',
                        dataTypes: {
                            personalData: 'Personal Data',
                            usageData: 'Usage Data',
                            trackingAndCookies: 'Tracking Technologies and Cookies',

                        },
                        listTitle: 'While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:',
                        listItemOne: 'Email address',
                        listItemTwo: 'First name and last name',
                        listItemThree: 'Usage Data',
                        paraOne: 'Usage Data is collected automatically when using the Service.',
                        paraTwo: 'Usage Data may include information such as Your Device\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.',
                        paraThree: 'When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.',
                        paraFour: 'We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.',
                        paraFive: 'Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. Learn more about cookies on the {paraFiveLink} article.',
                        paraFiveLink: 'Free Privacy Policy website',
                        cookiesTypes: {
                            browserCookies: 'Cookies or Browser Cookies.',
                            flashCookies: 'Flash Cookies.',
                            webBeacons: 'Web Beacons.',
                        },
                        cookiesListTitle: 'We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:',
                        cookiesListItemOne: '{cookiesTypes} A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.',
                        cookiesListItemTwo: '{cookiesTypes} Certain features of our Service may use local stored objects (or Flash Cookies) to collect and store information about Your preferences or Your activity on our Service. Flash Cookies are not managed by the same browser settings as those used for Browser Cookies. For more information on how You can delete Flash Cookies, please read "Where can I change the settings for disabling, or deleting local shared objects?" available at {link}',
                        cookiesListItemTwoLink: 'link',
                        cookiesListItemThree: '{cookiesTypes} Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).',
                        cookiesExplanationListTitle: 'We use both Session and Persistent Cookies for the purposes set out below:',
                        cookiesExplanationListItemOne: {
                            cookie: 'Necessary / Essential Cookies',
                            type: 'Type: Session Cookies',
                            administeredBy: 'Administered by: Us',
                            purpose: 'Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.',
                        },
                        cookiesExplanationListItemTwo: {
                            cookie: 'Cookies Policy / Notice Acceptance Cookies',
                            type: 'Type: Persistent Cookies',
                            administeredBy: 'Administered by: Us',
                            purpose: 'Purpose: These Cookies identify if users have accepted the use of cookies on the Website.',
                        },
                        cookiesExplanationListItemThree: {
                            cookie: 'Functionality Cookies',
                            type: 'Type: Persistent Cookies',
                            administeredBy: 'Administered by: Us',
                            purpose: 'Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.',
                        },
                        cookiesPara: 'For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.',
                    },
                    useData: {
                        title: 'Use of Your Personal Data',
                        definitions: {
                            provideAndMaintain: 'To provide and maintain our Service,',
                            manageAccount: 'To manage Your Account:',
                            performance: 'For the performance of a contract:',
                            contact: 'To contact You:',
                            provideYou: 'To provide You',
                            manageRequests: 'To manage Your requests:',
                            businessTransfers: 'For business transfers:',
                            outerPurposes: 'For other purposes:'
                        },
                        shareCases: {
                            serviceProviders: 'With Service Providers:',
                            businessTransfers: 'For business transfers:',
                            affiliates: 'With Affiliates:',
                            businessPartners: 'With business partners:',
                            outerUsers: 'With other users:',
                            yourConsent: 'With Your consent:'
                        },
                        personalDataUseCasesListTitle: 'The Company may use Personal Data for the following purposes:',
                        personalDataUseCasesListItemOne: '{definitions} including to monitor the usage of our Service.',
                        personalDataUseCasesListItemTwo: '{definitions} to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.',
                        personalDataUseCasesListItemThree: '{definitions} the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.',
                        personalDataUseCasesListItemFour: '{definitions} To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application\'s push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.',
                        personalDataUseCasesListItemFive: '{definitions} with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.',
                        personalDataUseCasesListItemSix: '{definitions} To attend and manage Your requests to Us.',
                        personalDataUseCasesListItemSeven: '{definitions} We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.',
                        personalDataUseCasesListItemEight: '{definitions} We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.',
                        shareCasesListTitle: 'We may share Your personal information in the following situations:',
                        shareCasesListItemOne: '{shareCases} We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.',
                        shareCasesListItemTwo: '{shareCases} We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.',
                        shareCasesListItemThree: '{shareCases} We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.',
                        shareCasesListItemFour: '{shareCases} We may share Your information with Our business partners to offer You certain products, services or promotions.',
                        shareCasesListItemFive: '{shareCases} when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.',
                        shareCasesListItemSix: '{shareCases} We may disclose Your personal information for any other purpose with Your consent.',
                    },
                    retentionData: {
                        title: 'Retention of Your Personal Data',
                        paraOne: 'The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.',
                        paraTwo: 'The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.',
                    },
                    transferData: {
                        title: 'Transfer of Your Personal Data',
                        paraOne: 'Your information, including Personal Data, is processed at the Company\'s operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.',
                        paraTwo: 'Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.',
                        paraThree: 'The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.',
                    },
                    disclosureData: {
                        title: 'Disclosure of Your Personal Data',
                        disclosureCases: {
                            businessTransactions: 'Business Transactions',
                            lawEnforcement: 'Law enforcement',
                            other: 'Other legal requirements',
                        },
                        paraOne: 'If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.',
                        paraTwo: 'Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).',
                        listTitle: 'The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:',
                        listItemOne: 'Comply with a legal obligation',
                        listItemTwo: 'Protect and defend the rights or property of the Company',
                        listItemThree: 'Prevent or investigate possible wrongdoing in connection with the Service',
                        listItemFour: 'Protect the personal safety of Users of the Service or the public',
                        listItemFive: 'Protect against legal liability',
                    },
                    securityOfData: {
                        title: 'Security of Your Personal Data',
                        paraOne: 'The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.',
                        CCPAPrivacyRights: {
                            title: 'CCPA Privacy Rights (Do Not Sell My Personal Information)',
                            paraOne: 'Under the CCPA, among other rights, California consumers have the right to:',
                            paraTwo: 'Request that a business that collects a consumer\'s personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.',
                            paraThree: 'Request that a business delete any personal data about the consumer that a business has collected.',
                            paraFour: 'Request that a business that sells a consumer\'s personal data, not sell the consumer\'s personal data.',
                            paraFive: 'If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.',
                        },
                        GDPRDataProtectionRights: {
                            title: 'GDPR Data Protection Rights',
                            paraOne: 'We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:',
                            paraTwo: 'The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.',
                            paraThree: 'The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.',
                            paraFour: 'The right to erasure – You have the right to request that we erase your personal data, under certain conditions.',
                            paraFive: 'The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.',
                            paraSix: 'The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.',
                            paraSeven: 'The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.',
                            paraEight: 'If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.',
                        },
                    },
                },
                childrenPrivacy: {
                    title: 'Children\'s Privacy',
                    paraOne: 'Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.',
                    paraTwo: 'Ask4Games does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.',
                },
                linksToOtherWebsites: {
                    title: 'Links to Other Websites',
                    paraOne: 'Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party\'s site. We strongly advise You to review the Privacy Policy of every site You visit.',
                    paraTwo: 'We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.',
                },
                privacyPolicyChanges: {
                    title: 'Changes to this Privacy Policy',
                    paraOne: 'We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.',
                    paraTwo: 'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.',
                    paraThree: 'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.',
                },
                contactUs: {
                    title: 'Contact Us',
                    contactListTitle: 'If you have any questions about this Privacy Policy, You can contact us:',
                    contactListItemOne: 'By email: {email}',
                    contactListItemTwo: 'By visiting this page on our website: {link}',
                },
            },
        },
        cookiePolicy: {
            title: 'Cookie Policy',
        },
        searchResults: {
            title: 'Search results',
            searchResultsTerm: 'Search results for',
        },
        advertise: {
            title: 'I want to advertise here',
            descriptionPara: 'Leave your contact information for us to promote your product. We\'ll get back to you within a week to discuss the terms of the contract. Here are four reasons why advertising is worth ordering from us.',
            sections: {
                firstSection: {
                    heading: 'Technical support.',
                    paragraph: 'Support throughout the life cycle of your ad. If any part of the layout you provided does not work correctly - we will fix it. We guarantee to meet the requirements of the client\'s terms of reference.'
                },
                secondSection: {
                    heading: 'Consultation.',
                    paragraph: 'If you are undecided about your wishes, we can help with advice. We don\'t need a clear task, we know how to think creatively.'
                },
                thirdSection: {
                    heading: 'Always on!',
                    paragraph: 'Contact us at any time with any question you may have. We\'ll be sure to listen and respond, even if you ask, "How was your day?"'
                },
                fourthSection: {
                    heading: 'Inexpensive.',
                    paragraph: 'Advertising is inexpensive with us. And that argument is truly exhaustive.'
                },
            },
        },
        passwordRecovery: {
            title: 'Forgot your Password?',
            note: 'Don’t worry! Just fill in your Email and we’ll send you a link to reset your password.',
            backToSignInLink: 'Back to Sign in',
            titleNewPassword: 'New Password',
            noteNewPassword: 'Please create a new password that you don’t use on any site.',
            confirmationPopup: {
                title: 'CHECK YOUR EMAIL',
                text: 'An email was sent to you. Check your email and follow the instructions to confirm password recovery.',
            },
        },
        error: {
            title: 'Error {errorCode}',
            error: 'Error',
            subTitle: 'Page Not Found',
            errorNote: 'The page you are looking for does not exist. It might have been moved or deleted.',
        },
        comments: {
            title: 'Comments',
            commentFormPlaceholder: 'Write your comment...',
            commentsCounter: '{n} comments | {n} comment | {n} comments',
            moderation: 'moderation',
            moderationTooltip: 'Your comment will be displaying after moderation',
            showOtherAnswers: 'Show other answers',
            show: 'Show',
            hide: 'Hide',
            showMore: 'Show more',
            answersCounter: '{n} answers | {n} answer | {n} answers',
            reply: 'Reply',
            commentDeleted: 'Comment has been deleted'
        },
        account: {
            title: 'Account',
            accountSettings: {
                title: 'Settings',
                baseInfo: 'Base Info',
                nickname: 'Nickname',
            },
            sections: {
                general: {
                    tabName: 'Account',
                    avatar: 'Avatar',
                    mainInfo: 'Main information',
                    mainInfoDescription: 'Please fill in your personal info',
                    linkedAccounts: 'Linked accounts',
                    linkedAccountsDescription: 'Your linked accounts will display here',
                    deleteAccount: 'Delete account',
                    deleteAccountDescription: 'If you delete your account, you won\'t be able to reactivate it later',
                },
                notifications: {
                    tabName: 'Notifications',
                    variants: {
                        variantTitle: 'Newsletters',
                        variantOne: 'New content on the site',
                        variantTwo: 'Responses to your comments',
                    },
                },
                password: {
                    tabName: 'Password',
                    changePassword: 'Change password',
                },
            },
            deletionConfirmationPopup: {
                title: 'PLEASE NOTE!',
                text: 'If you confirm the deletion, all your data will be permanently deleted from the site without the possibility of recovery. Are you sure you want to delete your account?',
            },
        },
    },
    buttons: {
        signInOrJoin: 'Sign in or Join',
        signInWithFacebook: 'Sign in with Facebook',
        signInWithGoogle: 'Sign in with Google',
        signInWithSteam: 'Sign in with Steam',
        signInWithTwitch: 'Sign in with Twitch.tv',
        signInWithXboxLive: 'Sign in with Xbox Live',
        signInWithPlaystationNetwork: 'Sign in with Playstation Network',
        subscribe: 'Subscribe',
        submit: 'Submit',
        showAllComments: 'Show all comments',
        showAll: 'Show All',
        showMore: 'Show more',
        supportCenter: 'Support center',
        addToLibrary: 'Add to library',
        addToFavorites: 'Add to Favorites',
        play: 'Play',
        viewAll: 'View all',
        viewDetails: 'View Details',
        viewComments: 'View Comments',
        signIn: 'Sign In',
        createMyAccount: 'Create My Account',
        registerNow: 'Sign Up Now',
        rate: 'Rate',
        goToTheGamePage: 'Go to the game page',
        getBonus: 'Get Bonus',
        restricted: 'Restricted',
        postMyReview: 'Post my review',
        publish: 'Publish',
        filter: 'Filter',
        openNewsMenu: 'Open news Menu',
        closeNewsMenu: 'Close news Menu',
        find: 'Find',
        confirm: 'Confirm',
        shareArticle: 'Share Article',
        resetPassword: 'Reset Password',
        sendMessage: 'Send Message',
        send: 'Send',
        goBack: 'Go Back',
        getStarted: 'Get started',
        readMore: 'Read more',
        downloadMore: 'Download more',
        reply: 'Reply',
        sendComment: 'Send a comment',
        shareOn: 'Share on {resource}',
        startWriting: 'Start writing',
        change: 'Change',
        openForm: 'Open form',
        upload: 'Upload',
        remove: 'Remove',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        delete: 'Delete',
        ok: 'Ok',
        resendEmail: 'Resend email',
        createAccount: 'Create account now'
    },
    forms: {
        labels: {
            accountRole: 'Account Type',
            userNameOrEmail: 'Username or email',
            email: 'Email',
            password: 'Password',
            confirmPassword: 'Confirm Password',
            firstName: 'First Name',
            lastName: 'Last Name',
            username: 'Username',
            emailAddress: 'Email address',
            enterEmailAddress: 'Enter email address',
            oldPassword: 'Old password',
            newPassword: 'New password',
            confirmNewPassword: 'Confirm new password',
            changePassword: 'Change Password',
        },
        placeholders: {
            userNameOrEmail: 'Username or email',
            email: 'Email',
            password: 'Password',
            confirmPassword: 'Confirm Password',
            firstName: 'First Name',
            lastName: 'Last Name',
            username: 'Username',
            emailAddress: 'Email address',
            enterEmailAddress: 'Enter email address',
            themeForWriting: 'Theme for writing',
            yourComment: 'Your comment',
            writeYourComment: 'Write your comment...',
            searchFormPlaceholders: {
                gamesSearchForm: 'Enter a phrase or the first letters of the game name',
            },
            selectDepartment: 'Select Department',
            yourName: 'Your name',
            message: 'Message',
            search: 'Search',
            oldPassword: 'Old password',
            newPassword: 'New password',
            confirmNewPassword: 'Confirm new password',
        },
        notes: {
            policyAcceptNote: 'By subscribing you are certifying that you have reviewed and accepted our updated {termsAndConditions} and {privacyPolicy}',
            ageAcceptNote: 'By subscribing you are certifying that you are over the age of 18.',
            emailMonitoringNote: 'We are asking you to specify your email address for comments monitoring purposes',
            passwordRequirements: 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)',
            passwordDoesNotMatch: 'Password confirmation does not match',
            passwordMustNotBeTheSame: 'Old and new passwords must not be the same',
        },
        loginForm: {
            forgotPassword: 'Forgot password?',
            keepMeLoggedIn: 'Keep Me Logged In',
            createAccountNote: 'Don’t have the {companyName} account?',
            alternateLogIn: 'Or Sign in with:',
        },
        joinForm: {
            userTabTitle: 'User',
            authorTabTitle: 'Author',
            accountInfo: 'Account Info:',
            latestPromotionsSend: 'Send me latest promotions',
            latestUpdatesSend: 'Send me the latest updates',
            alreadyHaveAnAccount: 'Already have an account?',
        },
        subscribeForm: {
            title: 'Subscribe for latest updates',
            policyNote: 'By subscribing you are certifying that you have reviewed and accepted our updated {privacyPolicy}.',
            privacyPolicyShort: 'Privacy Policy',
            conjunction: 'and',
        },
        contactForm: {
            titleAccent: 'Use this form',
            title: 'to get in touch',
        },
    },
    filters: {
        filterByPlatforms: {
            label: 'Platforms',
            placeholder: 'Platforms',
        },
        filterByGenres: {
            label: 'Genres',
            placeholder: 'Anything',
        },
        filterByYears: {
            label: 'Filter by years',
            placeholder: {
                term1: 'From',
                term2: 'To',
            },
        },
        filterByRating: {
            label: 'Filter by rating',
            placeholder: {
                term1: 'From',
                term2: 'To',
            },
            placeholderTwo: 'Rating',
        },
        filterByArticleType: {
            label: 'Article type',
            placeholder: 'All',
        },
        filterByCategory: {
            label: 'Categories',
            placeholder: 'Categories',
        },
        filterByDateOrder: {
            label: 'Date',
            fromNewToOld: 'From new to old',
            fromOldToNew: 'From old to new',
        },
    },
    evaluations: {
        yourPersonalRating: 'Your personal rating',
        evaluationByTheAuthor: 'Evaluation by the author',
    },
    gameGenres: {
        action: 'Action | Actions',
        adventure: 'Adventure | Adventures',
        simulator: 'Simulator | Simulators',
        fps: 'FPS | FPS',
        rolePlay: 'Role play | Role plays',
        esport: 'Esport | Esports',
        mmo: 'MMO | MMO',
        fighting: 'Fighting | Fightings',
        puzzle: 'Puzzle | Puzzles',
        platformer: 'Platformer | Platformers',
        survival: 'Survival | Survivals',
        racing: 'Racing | Racings',
        quest: 'Quest | Quests',
        horror: 'Horror | Horrors',
        stepByStepStrategy: 'Step-by-step strategy | Step-by-step strategies',
        browserGame: 'Browser game | Browser games',
        socialGame: 'Social game | Social games',
        shooter: 'Shooter | Shooters',
        slot: 'Slot | Slots',
        tableGame: 'Table game | Table games',
        lotteryGame: 'Lottery game | Lottery games',
        rpg: 'RPG | RPG',
        strategy: 'Strategy | Strategies',
        consularGame: 'Consular game | Consular games',
    },
    categories: {
        allCategories: 'All Categories',
    },
    commentsSection: {
        title: 'Latest comments',
    },
    userAuthorizationHeaderMenu: {
        dashboard: 'Dashboard',
        createArticle: 'Create Article',
        settings: 'Settings',
        signOut: 'Sign Out',
    },
    postShareLinks: {
        share: 'Share',
    },
    messages: {
        comments: {
            noCommentsYet: 'No comments yet...',
            leaveAComment: {
                message: '{signIn} or {join} to leave a comment',
                signIn: 'Sign in',
                join: 'join',
            },
        },
        postsInCategories: {
            noPostsInCategory: 'Sorry, no posts in this _category yet',
        },
    },
    cookiesNote: {
        title: {
            term1: 'This site uses',
            term2: 'Сookies',
        },
        note: `This site uses cookies and services to collect technical data about visitors (IP address, location data, etc.)
               in order to keep it working and to improve the quality of our service.
               By continuing to use our site, you automatically agree to the use of these technologies.`,
    },
    popup: {
        emailConfirmation: {
            title: 'Confirm your Email',
            text: 'An email was sent to you. Open the email and follow the link to confirm your email. You will then be able to log in to your account.',
        },
        emailChange: {
            title: 'Confirm your Email',
            text: 'You changed your account email. An email was sent to you. Open the email and follow the link to confirm your email.',
        },
        emailConfirm: {
            title: 'Your Email Confirmed',
            text: 'To login into your account, use the data that you provided during registration',
        },
        emailVerification: {
            title: 'Email Verification',
            title1: 'Email already exists',
            title2: 'The account has not been verified yet',
            text: 'We have sent a verification mail to {email}. Please activate your account with the link in this mail. If you cannot find the mail, please also check the Spam folder!',
            additionalText: 'If you have not received a verification email, you can resend the verification mail.'
        },
        emailVerificationError: {
            title: 'Something went wrong',
            text: 'Please try again',
        },
        accountNotFound: {
            title: 'Account not found',
            text: 'Hi, we were not able to find an Account on Ask4games. Would you like to create an Account?',
        },
        usernameAlreadyExist: {
            title: 'Username already exists',
            text: 'Please try another name.',
        },
        passwordRecovered: {
            title: 'The password was successfully recovered',
            text: 'To login into your account, use your email and new password',
        },
        invalidPassword: {
            title: 'Invalid password',
            text: 'Please try again',
        },
    }
}
